import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from "../../../apa/Launcher";
import DeviceStorage from "../../../../components/DeviceStorage/DeviceStorage";
import Utils from '../../../../utils/Utils';
import logger from 'src/utils/logger/logger';

class LinealPredictiveV1Task extends AbstractRequestTask {
  constructor(parameters) {
    super();
    this.customParameters = parameters;
  }

   APAFilters(){
      return Utils.getApaMetadataKey('byr_filterlist_configuration', '{}', 'filterlist')
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete params.device_id;
    delete params.device_name;
    delete params.device_so;
    const epg_version = DeviceStorage.getItem('epgVersion');
    const APA =this.APAFilters();
    if(APA){
        this.customParameters.filterlist = APA;
        this.customParameters.tenant_code = 'clarovideo';
    }
    if(epg_version){
      this.customParameters.epg_version = epg_version;
    }
    return Object.assign({}, params, this.customParameters);
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/search/v1/linealpredictive`;
  }


  parseErrors(err) {
    logger.debug('[UserFav] - api errors' +  err);
  }

  getRetriesNumber() {
        return 0;
  }

  getShowErrorModal(){
    return false;
  }


  success(data, b) {
    this.resolve(data);
  }


}

export default LinealPredictiveV1Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/v1/LinealPredictiveV1Task.js